import { useContext, useState } from "react";
import { t } from "i18next";
import { PrimaryButton } from "@fluentui/react";
import { Link, useNavigate } from "react-router-dom";
import { AuthRoutes, USERTYPES } from "../../constants/Constants";
import { ACTIONS } from "../../constants/Constants";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import HPColumns from "./HPColumns";
import userContext from "../../context/users/UserContext";
import { useTranslation } from "react-i18next";
import { changeStatusHP, changeSysStatusHP, deleteHP, deleteSysHP, fetchHPList, fetchSysHPList } from "../../service/HPService";
import loaderContext from "../../context/loader/LoaderContext";
import toastContext from "../../context/toast/ToastContext";
import ConfirmModal from "../../components/Modal/ConfirmModal";

const HangingProtocolList = () => {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const { roles } = useContext(userContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);

  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [dataQueryState, setDataQueryState] = useState({});
  const [deletedId, setDeletedId] = useState();

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });

  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <Link
          to={AuthRoutes.ADDHANGINGPROTOCOL}
          state={{ action: ACTIONS.ADD }}
        >
          <div id="add-hanging-protocol" className="add-button-list-view">
            <PrimaryButton
              text={t("button.add-hanging-protocol")}
              className={
                "common-default-active-button list-view-top-buttons-styles"
              }
            />
          </div>
        </Link>
      ),
    },
  ];

  const options = [{ key: "name", text: "Name" }];

  const getHPList = async (options) => {
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 10,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
    };

    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      let response;
      if (roles[0] === USERTYPES.ADMIN) {
        response = await fetchSysHPList(body);
      } else {
        response = await fetchHPList(body);
      }
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        data = response.data.data.content;
        pageCount = response.data.data.totalPages;
        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      console.log(e);
    }
  };

  const changeActiveStatus = async (event, data, cell) => {
    event.stopPropagation();
    let response;
    try {
      if (roles[0] === USERTYPES.ADMIN) {
         response = await changeSysStatusHP(
        cell.row.original.id,
        cell.row.original.active ? false : true
      );
      } else {
        response = await changeStatusHP(
        cell.row.original.id,
        cell.row.original.active ? false : true
      );
      }

      
      if (response.status === 200 && response.data.result === "SUCCESS") {
        ReloadData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  function ReloadData(id) {
    let newIndex = -1;
    dataQueryState?.data?.rows.filter((row, index) => {
      if (row.id == id) {
        newIndex = index;
        return true;
      }
      return false;
    });
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState,
      };
      if (newValue.data.rows[newIndex] != null) {
        if (newValue.data.rows[newIndex].active) {
          newValue.data.rows[newIndex].active = false;
        } else {
          newValue.data.rows[newIndex].active = true;
        }
      }
      return newValue;
    });
  }

  const deleteConfirmModal = (event, data, cell) => {
    event.stopPropagation();
    setDeletedId(cell.row.original.id);
    setShowDeleteConfirmModal(true);
  };

  const handleRemoveHP = async () => {
    let response;
    try {
      if (roles[0] === USERTYPES.ADMIN) {
        response = await deleteSysHP(deletedId);
      } else {
        response = await deleteHP(deletedId);
      }
      if (response.status === 200 && response.data.result === "SUCCESS") {
        showToastv2("success", t("hanging-protocol.deleted-success"));
      } else {
        showToastv2("error", response.data.message);
      }
      setShowDeleteConfirmModal(false);
      setPagination(() => {
        const newItem = { ...paginationObj };
        newItem.pageIndex = 0;
        return newItem;
      });

      setTimeout(() => {
        setFilterObj(() => {
          const newItem = { ...filterObj };
          newItem.filterUpdate = newItem.filterUpdate + 1;
          return newItem;
        });
      }, 100);
    } catch (e) {
      console.log(e);
    }
  };

  const columns = HPColumns(changeActiveStatus, deleteConfirmModal, roles[0]);

  const handleUserClick = async (cell) => {
    cell = cell.row.original;
    navigate(AuthRoutes.VIEWHANGINGPROTOCOL + "?id=" + cell.id);
  };

  const handleApplyClick = (filterValue) => {
    if (filterValue != undefined) filterValue = filterValue.trim();
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = filterValue;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  return (
    <>
      {showDeleteConfirmModal && (
        <ConfirmModal
          handleConfirm={handleRemoveHP}
          handleNotConfirm={() => {
            setShowDeleteConfirmModal(!showDeleteConfirmModal);
          }}
          showConfirmModal={showDeleteConfirmModal}
          message={t("hanging-protocol.delete-hanging-protocol")}
          title={t("confirm-message.confirm")}
          confirmButtonText={t("confirm-message.yes")}
        />
      )}

      <div className="main-container-body">
        <ListViewV3
          buttonsTopBar={buttonsTopBar}
          sortDropdownOptions={options}
          fetchData={getHPList}
          showSideBySide={false}
          columns={columns}
          handleUserClick={handleUserClick}
          filterObj={filterObj}
          setFilterObj={setFilterObj}
          setDataQueryState={setDataQueryState}
          dataQueryState={dataQueryState}
          sortObj={sortObj}
          setSortObj={setSortObj}
          setPagination={setPagination}
          handleApplyClick={handleApplyClick}
          paginationObj={paginationObj}
          unqiueKey={"HangingProtocol"}
          heading={t("navbar.hanging-protocol")}
          placeholder={t("hanging-protocol.name")}
          fullLength={true}
          fullLengthForRow={true}
        />

        {/* <ListViewV3
        buttonsTopBar={buttonsTopBar}
        sortDropdownOptions={options}
        fetchData={fetchClientList}
        showSideBySide={false}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        setDataQueryState={setDataQueryState}
        dataQueryState={dataQueryState}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        handleApplyClick={handleApplyClick}
        paginationObj={paginationObj}
        unqiueKey={"Client"}
        placeholder={t("placeholder.firm-name")}
        pointer={roles[0] === USERTYPES.RADIOLOGIST ? false : true}
        heading={roles[0] == USERTYPES.FIRMADMIN || roles[0] === USERTYPES.FIRMTECHNICIAN || roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.RADIOLOGIST ? t("navbar.clients") : t("navbar.firms")}
      /> */}

        {/* <div id="add-hanging-protocol" className="add-button-list-view">
        <Link to={AuthRoutes.ADDHANGINGPROTOCOL}>
          <PrimaryButton
            text={t("button.add-hanging-protocol")}
            className={
              "common-default-active-button list-view-top-buttons-styles"
            }
          />
        </Link>
      </div>
      <div>
        <Link
          to={AuthRoutes.VIEWHANGINGPROTOCOL + "?id=" + 1}
          state={{ action: ACTIONS.VIEW }}
        >
          <div id="view-hanging-protocol" className="add-button-list-view">
            <PrimaryButton
              text={"view"}
              className={
                "common-default-active-button list-view-top-buttons-styles"
              }
            />
          </div>
        </Link>
      </div> */}
      </div>
    </>
  );
};

export default HangingProtocolList;
